import { render, staticRenderFns } from "./OneCartValueComponent.vue?vue&type=template&id=04a39350&lang=pug&"
import script from "./OneCartValueComponent.vue?vue&type=script&lang=ts&"
export * from "./OneCartValueComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports